interface ElementProps {
  src: string;
  alt: string;
  height: string;
  width: string;
  className?: string;
}

// ? In future we will use this component to optimize images
const Image = ({alt, height, src, width, className}: ElementProps) => {
  return (
    <img
      src={src}
      alt={alt}
      height={height}
      width={width}
      className={className}
    />
  );
};

export default Image;
